import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { keys } from '@/lib/queryKeys';
import { fetchDailySummary } from './api';

/** Branch-scoped — OPD/pharmacy revenue and registrations are per-site. */
export function useDailySummary() {
  const { branchVersion } = useAuth();
  return useQuery({
    queryKey: [...keys.reports.dailySummary(), branchVersion],
    queryFn: fetchDailySummary,
  });
}
